import Vue from "vue";
import Vuex from "vuex";
import breakpoints from "./breakpoints.json";
Vue.use(Vuex);
const mq = new Vuex.Store({
  state: {
    current: null,
    min: {
      xxs: false,
      xs: false,
      sm: false,
      md: false,
      lg: false,
      xl: false,
      xxl: false
    },
    max: {
      xxs: false,
      xs: false,
      sm: false,
      md: false,
      lg: false,
      xl: false,
      xxl: false
    }
  },
  mutations: {
    checkBreakpoint(state) {
      let previous = "xxs";
      let current = null;
      Object.keys(state.min).forEach(key => {
        state.min[key] = window.innerWidth >= breakpoints[key];
      });

      Object.keys(state.max).forEach(key => {
        state.max[key] = window.innerWidth < breakpoints[key] - 1;
        // define current breakpoint
        if (current === null && state.max[key] === true) {
          current = previous;
          state.current = current;
        }
        previous = key;
      });
      if (current === null) {
        state.current = "xxl";
      }
      Vue.set(state, "current", state.current);
      Vue.set(state, "min", state.min);
      Vue.set(state, "max", state.max);
    }
  },
  actions: {},
  modules: {}
});

mq.commit("checkBreakpoint");
window.addEventListener("resize", () => {
  mq.commit("checkBreakpoint");
});
// Check if user token is valid

export default mq;
